<template>
  <v-container fill-height>
    <v-row
      align="center"
      justify="center"
      no-gutters
    >
      <v-col>
        <v-card width="450px" class="pa-5 mx-auto" flat>
          <div style="text-align: center; width: 100%">
            <img class="ml-n2" style="max-height: 130px" :src="logo"/>
          </div>
          <div style="text-align: center">
            <span style="font-size: 13px; font-weight: 300; letter-spacing: .5px">Farsoft Cloud ERP | Módulo Lucratividade</span>
          </div>
          <v-form>
            <v-text-field
              class="mt-6 fs-input"
              type="text"
              v-model="email"
              label="E-mail"
              placeholder=" "
              autofocus
              spellcheck="false"
              outlined
              dense
            />
            <v-text-field
              class="mt-n2 fs-input"
              type="password"
              v-model="senha"
              @keyup.enter="formSubmit"
              spellcheck="false"
              label="Senha"
              placeholder=" "
              hide-details
              outlined
              dense
            />
            <v-btn block @click="formSubmit()" :disabled="loading" class="mt-4" color="primary">
              Entrar
            </v-btn>
          </v-form>
          <!-- <div class="mt-5" style="text-align: center; width: 100%">
            <router-link to="forgot">
              <u>Esqueceu sua senha?</u>
            </router-link>
          </div> -->
          <div class="fs-device-desc">
            {{ this.getDevice.browser_nome }} | Versão: {{ this.getDevice.browser_versao }} | S.O.: {{
              this.getDevice.os_nome
            }} {{ this.getDevice.os_versao }}
            <br>
            ID: {{ this.getHash }}
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Vue from 'vue'

export default {
  metaInfo: {
    title: 'Login'
  },
  data () {
    return {
      codigo: '',
      device: {},
      email: '',
      senha: '',
      userId: '',
      bgImage: require('@/assets/images/bg2.jpg'),
      logo: require('@/assets/images/logo.png'),
      signInImage: require('@/assets/images/photo-long-5.jpg')
    }
  },
  computed: {
    ...mapGetters('authData', ['loggedInUser', 'loading', 'error']),
    ...mapGetters('device', ['getDevice', 'getHash']),
    validation () {
      return this.userId.length > 4 && this.userId.length < 13
    }
  },

  async mounted () {
    this.device = await this.identificarDevice()
  },
  methods: {
    ...mapActions('authData', ['login', 'signOut']),
    ...mapActions('device', ['identificarDevice', 'findDevice', 'addDevice', 'editDevice']),
    ...mapMutations('device', ['DEVICE']),
    ...mapMutations('global', ['setLoading']),

    // Método do Botão Entrar (type = submit)
    async formSubmit () {
      this.setLoading(true)
      // console.log('formSubmit')
      const deviceFingerPrint = Object.assign({}, this.getDevice)
      deviceFingerPrint.fingerprint = Vue.$cookies.get('__farsoft_fingerprint')

      // Chama a mutation para atualizar a chave fingerPrint (só pode ser feita depois de ter lido)
      this.DEVICE(deviceFingerPrint)

      const login = await this.login({ email: this.email, senha: this.senha, aplicacao: 'webmobile' })
      if (login) {
        if ((this.email !== 'farnetani@gmail.com') && (this.email !== 'jrboss@fortkol.com.br')) {
          this.$toast.error('Você não tem acesso a esse Módulo!', 'Acesso Restrito!')
          this.email = ''
          this.senha = ''
          this.signOut()
          // this.$router.push('/app/sessions/signIn')
        } else {
          // Verificar se o fingerprint do dispositivo está cadastrado e liberado
          // Tenta localizar no BD o device com o fingerprint
          const dispositivo = await this.findDevice(deviceFingerPrint.fingerprint)
          if (dispositivo && dispositivo.error) {
            // Inclui o DEVICE(dispositivo) no banco de dados
            const addResult = await this.addDevice(deviceFingerPrint)
            // Atualiza o device do state para pegar o ID
            this.DEVICE(addResult)
            this.$router.push('/app/sessions/device')
          } else {
            // Atualiza o device do state com o dispositivo encontradopara pegar o ID
            this.DEVICE(dispositivo)
            if (dispositivo.liberado === 'N') {
              this.$router.push('/app/sessions/device')
            } else {
              // if ((this.email !== 'farnetani@gmail.com') && (this.email !== 'adm@fortkol.com.br')) {
              //   this.$toast.error('Você não tem acesso a esse Módulo!', 'Acesso Restrito!')
              //   this.signOut()
              // }
              window.localStorage.setItem('fingerprint', Vue.$cookies.get('__farsoft_fingerprint'))
              // Redireciona para o MENU
              this.$router.push('/app/dashboards/home')
            }
          }
        }
      }
      this.setLoading(false)
    }
  },
  watch: {
    error (val) {
      if (val != null) {
        this.$toast.error('Verifique e-mail e senha informados!', 'Dados Incorretos!')
      }
    }
  }
}
</script>

<style scoped>
.fs-input {
  font-size: 12px;
}

.fs-device-desc {
  text-align: center;
  margin-top: 40px;
  margin-bottom: -10px;
  font-size: 10px;
  padding-left: 5px;
  padding-right: 5px;
  font-weight: 300;
  letter-spacing: .4px;
  color: black;
}
</style>
